import { Box, styled } from "@mui/material";
import { SinglePageFormProps } from "./types";
import ActionButtons from "components/form-components/action-buttons";
import FormModal from "components/form-components/form-modal";
import { useRef } from "react";

const Form = styled("form")(({ theme }) => ({
  flex: 1,
  overflowY: "hidden",
  display: "flex",
}));

const SinglePageForm = ({
  id,
  show,
  handleClose,
  handleSubmit,
  dialogProps,
  title,
  children,
  headerChildren,
  mode,
  actionButtons,
  posting,
  formContainerSx,
  formSx,
}: SinglePageFormProps) => {
  const formRef = useRef<HTMLFormElement>(null);

  return (
    <FormModal
      open={show}
      handleClose={handleClose}
      title={title}
      dialogProps={{
        ...dialogProps,
        PaperProps: {
          ...(dialogProps?.PaperProps || {}),
          sx: {
            ...(dialogProps?.PaperProps?.sx || {}),
            overflowY: "hidden",
          },
        },
      }}
      headerChildren={headerChildren}
    >
      {/* Top Bar */}
      <Form id={id || undefined} onSubmit={(event) => handleSubmit(event)} ref={formRef} sx={formSx || {}}>
        {/* Body */}
        <Box
          sx={(theme) => ({
            padding: theme.spacing(6),
            ...(formContainerSx || {}),
            flexGrow: 1,
            overflowY: "auto",
          })}
        >
          {children}
        </Box>
      </Form>

      {/* Footer */}
      <Box
        sx={(theme) => ({
          display: "block",
          height: "65px",
          maxHeight: "65px",
          flexShrink: 0,
        })}
      >
        <Box
          sx={(theme) => ({
            display: "flex",
            justifyContent: "flex-end",
            gap: 3,
            flexWrap: "wrap",
            padding: `${theme.spacing(3)} ${theme.spacing(6)}`,
            bottom: 0,
            borderTop: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.default,
            zIndex: 2,
          })}
        >
          <ActionButtons
            cancel={actionButtons.cancel}
            submit={actionButtons.submit}
            additionalActions={actionButtons.additionalActions}
            handleClose={handleClose}
            mode={mode}
            posting={posting}
            formRef={formRef}
            formId={id}
          />
        </Box>
      </Box>
    </FormModal>
  );
};

export default SinglePageForm;
